import { useState } from "react";
import { createSearchParams } from "react-router-dom";


export const ContractDropdownOption = ({contract, client, vendor, category}) => {
    function isValidDate(dateStr) {
      try {
        const date = new Date(dateStr);
        return !isNaN(date.getTime());
      } catch {
        return false;
      }
    }
    const [isValidContract, setIsValidContract] = useState(()=> {
        let st = contract["start_date"]
        let et = contract["end_date"]
        return isValidDate(st) && isValidDate(et);
    });

    function handleNavigate(obj) {
      const params = createSearchParams({ 
      client_id: client?.client_id,
      client_name: client?.client,
      client_list_page_no: 1,
      client_list_sort_key: '',
      client_list_sort_order: '',

      vendor_id: vendor?.vendor_id,
      vendor_name: obj?.vendor,
      vendor_list_page_no : 1,
      vendor_list_sort_key: '',
      vendor_list_sort_order: '',
      category_name: category?.category_name,
      category_id: category?.category_id,

      contract_id: obj._id,
      contract_name: contract.fname,
      contract_list_page_no: 1,
      contract_list_sort_key: '',
      contract_list_sort_order: '',

    }).toString();

    window.open(`/my-contract-details?${params}`, '_blank'); // 
          
    }
    
  return <li key={contract['_id']}>
  {isValidContract ? (
    contract['fname']
  ) : (
    <>
   <span onClick={() => handleNavigate(contract)} style={{ color: 'red', marginRight: '8px' }} title="Invalid contract dates">
        &#10060;
      </span>
        {contract['fname']}
      
      
    </>
  )}
</li>


}